module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "good"
  }, [_h('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_h('ul', [_vm._l((_vm.goods), function(item, index) {
    return _h('li', {
      staticClass: "menu-item border-1px",
      class: {
        'current': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectMenu(index, $event)
        }
      }
    }, [_h('span', {
      staticClass: "text"
    }, [_h('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type > 0),
        expression: "item.type>0"
      }],
      staticClass: " icon",
      class: _vm.classMap[item.type]
    }), _vm._s(item.name) + "\n        "])])
  })])]), " ", _h('div', {
    ref: "foodWrapper",
    staticClass: "foods-wrapper"
  }, [_h('ul', [_vm._l((_vm.goods), function(item) {
    return _h('li', {
      staticClass: "food-list food-list-hook"
    }, [_h('h1', {
      staticClass: "title"
    }, [_vm._s(item.name)]), " ", _h('ul', [_vm._l((item.foods), function(food) {
      return _h('li', {
        staticClass: "food-item",
        on: {
          "click": function($event) {
            _vm.selectFood(food, $event)
          }
        }
      }, [_h('div', {
        staticClass: "icon"
      }, [_h('img', {
        attrs: {
          "src": food.icon,
          "alt": "",
          "width": "57"
        }
      })]), " ", _h('div', {
        staticClass: "content"
      }, [_h('h2', {
        staticClass: "name"
      }, [_vm._s(food.name)]), " ", _h('p', {
        staticClass: "desc"
      }, [_vm._s(food.description)]), " ", _h('div', {
        staticClass: "extra"
      }, [_h('span', {
        staticClass: "count"
      }, ["月售" + _vm._s(food.sellCount)]), _h('span', {
        staticClass: "count"
      }, ["好评" + _vm._s(food.rating)])]), " ", _h('div', {
        staticClass: "price"
      }, [_h('span', {
        staticClass: "now"
      }, ["￥" + _vm._s(food.price)]), _h('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.oldPrice),
          expression: "food.oldPrice"
        }],
        staticClass: "old"
      }, ["￥" + _vm._s(food.oldPrice)])]), " ", _h('div', {
        staticClass: "cartControl-wrapper"
      }, [_h('cartControl', {
        attrs: {
          "food": food
        },
        on: {
          "increment": _vm.incrementTotal
        }
      })])])])
    })])])
  })])]), " ", _h('div', [_h('shopCart', {
    ref: "shopCart",
    attrs: {
      "select-foods": _vm.selectFoods,
      "delivery-price": _vm.seller.deliveryPrice,
      "min-price": _vm.seller.minPrice
    }
  }), " ", _h('food', {
    ref: "food",
    attrs: {
      "food": _vm.selectedFood
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.vue-loader@10.0.2/lib/template-compiler.js?id=data-v-26361d18!./~/.vue-loader@10.0.2/lib/selector.js?type=template&index=0!./src/components/goods/goods.vue
// module id = 45
// module chunks = 1